exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "._3bUEz9xa51PZBPuOUxj3oH{height:100%}._3bUEz9xa51PZBPuOUxj3oH p{margin-bottom:0;margin-top:0}._3bUEz9xa51PZBPuOUxj3oH span{font-weight:700}.JpMM8HcUVXJE5AV03zmYY:first-child{margin-top:0}", ""]);

// exports
exports.locals = {
	"colorSideNav": "#008a8a",
	"OverallDevelopmentCard": "_3bUEz9xa51PZBPuOUxj3oH",
	"OverallDevelopmentCard_subtitle": "JpMM8HcUVXJE5AV03zmYY"
};


//////////////////
// WEBPACK FOOTER
// ../node_modules/css-loader?{"root":".","modules":true,"import":false,"importLoaders":1}!../node_modules/postcss-loader/lib?{"config":{"path":"/var/lib/jenkins/workspace/build-omni-operation-ui_develop/node_modules/omni-common-ui/postcss.config.js"}}!./containers/Group/ProgressReport/StudentReportView/OverallDevelopmentCard/style.postcss
// module id = 1491
// module chunks = 0